import { combineReducers } from 'redux';

import apiError from './apiError';
import data from './data';
import isFetching from './isFetching';

/**
 * @typedef {{
 *  apiError: string,
 *  isFetching: boolean,
 *  data: import('./data').DealerTimelineReducer
 * }} StatisticsTimelineReducer
 */

export default combineReducers({
  data,
  apiError,
  isFetching,
});
